import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { EditorHelp } from '../_EditorHelp/_EditorHelp';

export default function FullWidth(props: ComponentProps): JSX.Element {
	return (
		<>
			<EditorHelp text="Full Width START" indent color={'blue'} />
			<section>
				<Placeholder name="rcnlearn-fullwidth" rendering={props.rendering} />
			</section>
			<EditorHelp text="Full Width END" indent color={'blue'} />
		</>
	);
}
